import React from 'react'
import { ICheckProps, TVal } from '../Input.types'
import css from '../Input.module.scss'

export const Switch = <T extends TVal>({
  checked,
  removeInput,
  className,
  disabled,
  invalid,
  label,
  value,
  onChange,
  ...passingProps
}: ICheckProps<T>) => {
  return (
    <label
      className={`${css.wrapper} ${disabled ? css.isDisabled : ''} ${
        invalid ? css.isInvalid : ''
      }  ${className}`}
    >
      <div
        className={`${css.switchLabel} ${disabled ? css.isDisabled : ''} ${
          invalid ? css.isInvalid : ''
        }`}
      >
        {!removeInput && (
          <input
            type="checkbox"
            checked={checked}
            onChange={() => onChange(value || !checked)}
            disabled={disabled}
            {...passingProps}
          />
        )}

        <span className={css.slider} />
      </div>

      {label && <div className={css.label}>{label}</div>}
    </label>
  )
}
